import { ErrorSummary } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";

export const AvbestillBekreftelseManglerFeil = () => {
  const { t } = useTranslation();
  return (
    <ErrorSummary className="space-y-4 border border-balder-border-danger-strong">
      <ErrorSummary.Heading>
        {t("pages.avtaler.avbestilling.feil-bekreft-avbestilling-tittel")}
      </ErrorSummary.Heading>
      <ErrorSummary.List>
        <ErrorSummary.Item>
          {t("pages.avtaler.avbestilling.feil-bekreft-avbestilling")}
        </ErrorSummary.Item>
      </ErrorSummary.List>
    </ErrorSummary>
  );
};
